<div style="height: 100%; position: relative">
  <mat-toolbar [style.background-color]="coreConfiguration.isMobile || useMobileHeaderColors ? '#039be5' : '#fff'">
    <button *ngIf="backButtonEnabled()" (click)="navigateBack()" mat-icon-button style="margin: auto 0.5em auto 0;">
      <mat-icon [style.color]="coreConfiguration.isMobile ? '#fff' : '#039be5'">chevron_left</mat-icon>
    </button>
    <button *ngIf="menuButtonEnabled()" (click)="openMenu()" #menuButton mat-icon-button style="margin: auto 0.5em auto 0;">
      <mat-icon style="color: white">menu</mat-icon>
    </button>
    <div [style.color]="coreConfiguration.isMobile || useMobileHeaderColors ? '#fff' : '#039be5'" style="overflow: hidden; flex: 1 1 auto">
      <p style="font-size: x-large; font-weight: bold; padding: 0; margin: 0; text-overflow: ellipsis;">
        <ng-content select="[pagetitle]"></ng-content>
      </p>
    </div>

    <span style="flex: 1 1 auto;"></span>
    <div style="margin: auto;">
      <ng-content select="[pageheaderactions]"></ng-content>

      <ng-template [ngIf]="!showSearchBox && coreConfiguration.isMobile && coreConfiguration.useFilterDialog() && filterInputs != null">
        <button style="margin-left: 0.5em; color: white" mat-icon-button #filterButtonHeader (click)="showFilterDialog()">
          <mat-icon>filter_list</mat-icon>
        </button>
      </ng-template>
    </div>
    <div>
      <ng-container *ngIf="!coreConfiguration.useFilterDialog()" [ngTemplateOutlet]="filterInputs"></ng-container>
    </div>
    <app-search-field style="margin-left: 0.5em;" *ngIf="showSearchBox && !coreConfiguration.isMobile"
                      (search)="search.emit()"
                      [(searchQuery)]="searchQuery"></app-search-field>
  </mat-toolbar>

  <div *ngIf="showMobileSearchBox()" class="search_field_container">
    <app-search-field style="flex: 1 1 auto" (search)="search.emit()" [(searchQuery)]="searchQuery"></app-search-field>
    <button style="margin-left: 0.5em" mat-icon-button (click)="showFilterDialog()" #filterButtonSearch *ngIf="coreConfiguration.useFilterDialog() && filterInputs != null">
      <mat-icon>filter_list</mat-icon>
    </button>
  </div>

  <div class="page_content"
       [style.max-height]="getPageContentMaxHeightCssCalculation()">
    <ng-content select="[pagecontent]"></ng-content>
  </div>

  <mat-progress-bar class="progress_bar" [style.bottom]="footer.childElementCount > 0 ? 'calc(64px)' : 'calc(0)'"
                    *ngIf="showProgress" mode="indeterminate"></mat-progress-bar>

  <div #footer class="page_footer">
    <ng-content select="[pagefooter]"></ng-content>
  </div>
</div>
